/*
  Mecca Books Collection catalog — mobile Sort/Filter bottom sheets, AJAX
  sort/filter (no full page reload), plus "load more" in two modes:
  - button: click fetches the next page and appends products in place
    (no full navigation), falling back to the real href if JS fails.
  - infinite: same fetch-and-append, auto-triggered via
    IntersectionObserver as the trigger nears the viewport.

  Sort/filter changes (the facets form, plus the active-filter chips and
  "Clear all") are intercepted and fetched via the Sections Rendering API
  (?section_id=...), swapping [data-mb-catalog-gridwrap] + the live count
  in place. The URL bar is updated via history.pushState so the filtered
  view stays bookmarkable/shareable; browser back/forward does a real
  reload to guarantee correctness rather than re-implementing AJAX state
  restoration.

  Mobile Sort/Filter sheets (.mb-catalog__sheet-scrim) don't duplicate any
  filtering logic: the Sort sheet just sets the real <select name="sort_by">
  and dispatches its native 'change' event (which the existing form
  listener below already handles); the Filter sheet IS the same <aside>/
  <form> used on desktop, just repositioned via CSS. Both sheets live
  inside [data-mb-catalog-gridwrap], so they get replaced along with
  everything else on every AJAX swap — initSheets() is re-run after each
  swap the same way initFilterForm/initFilterLinks already are.
*/
(function () {
  function initSheets(root) {
    var scrims = root.querySelectorAll('[data-mb-catalog-sheet-scrim]');

    function closeAll() {
      scrims.forEach(function (s) { s.classList.remove('mb-catalog__sheet-scrim--open'); });
      document.body.classList.remove('mb-catalog-sheet-open');
    }

    function open(name) {
      scrims.forEach(function (s) {
        var match = s.getAttribute('data-mb-catalog-sheet-scrim') === name;
        s.classList.toggle('mb-catalog__sheet-scrim--open', match);
      });
      document.body.classList.add('mb-catalog-sheet-open');
    }

    root.querySelectorAll('[data-mb-catalog-open]').forEach(function (btn) {
      if (btn._mbBound) return;
      btn._mbBound = true;
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-mb-catalog-open'));
      });
    });

    root.querySelectorAll('[data-mb-catalog-close]').forEach(function (btn) {
      if (btn._mbBound) return;
      btn._mbBound = true;
      btn.addEventListener('click', closeAll);
    });

    scrims.forEach(function (scrim) {
      if (scrim._mbBound) return;
      scrim._mbBound = true;
      scrim.addEventListener('click', function (e) {
        if (e.target === scrim) closeAll();
      });
    });

    // Sort sheet rows: set the real <select>, fire change (existing form
    // listener AJAX-applies it), mark active, close.
    var sortSelect = root.querySelector('[data-mb-catalog-sort-select]');
    root.querySelectorAll('[data-mb-catalog-sort-opt]').forEach(function (opt) {
      if (opt._mbBound) return;
      opt._mbBound = true;
      opt.addEventListener('click', function () {
        var value = opt.getAttribute('data-value');
        root.querySelectorAll('[data-mb-catalog-sort-opt]').forEach(function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        closeAll();
        if (sortSelect && sortSelect.value !== value) {
          sortSelect.value = value;
          sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Filter sheet footer: "Show N results" just closes (checkbox changes
    // already AJAX-apply live via the form's own 'change' listener, same
    // as desktop); "Clear" reuses the same clear-all link/behavior.
    var applyBtn = root.querySelector('[data-mb-catalog-filter-apply]');
    if (applyBtn && !applyBtn._mbBound) {
      applyBtn._mbBound = true;
      applyBtn.addEventListener('click', closeAll);
    }

    var clearBtn = root.querySelector('[data-mb-catalog-filter-clear]');
    if (clearBtn && !clearBtn._mbBound) {
      clearBtn._mbBound = true;
      clearBtn.addEventListener('click', function () {
        var clearLink = root.querySelector('[data-mb-catalog-gridwrap] a.mb-catalog__clear');
        var browserUrl = clearLink
          ? clearLink.getAttribute('href')
          : root.getAttribute('data-collection-url') + '?sort_by=' + (sortSelect ? sortSelect.value : '');
        var sectionId = root.getAttribute('data-section-id');
        var joiner = browserUrl.indexOf('?') === -1 ? '?' : '&';
        var fetchUrl = browserUrl + joiner + 'section_id=' + sectionId;
        closeAll();
        swapCatalog(root, browserUrl, fetchUrl);
      });
    }
  }

  function initLoadMore(container) {
    var root = container.closest('[data-mb-catalog-root]');
    if (!root) return;
    var grid = root.querySelector('[data-mb-catalog-grid]');
    var mode = container.getAttribute('data-mode');
    var btn = container.querySelector('[data-mb-catalog-loadmore-btn]');
    var spinner = container.querySelector('[data-mb-catalog-loadmore-spinner]');
    var observer = null;

    function setLoading(isLoading) {
      if (spinner) spinner.hidden = !isLoading;
      if (btn) btn.hidden = isLoading;
    }

    function loadNext(url) {
      if (!url) return;
      setLoading(true);

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-mb-catalog-grid]');
          var newLoadmore = doc.querySelector('[data-mb-catalog-loadmore]');

          if (newGrid && grid) {
            grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          }

          if (newLoadmore) {
            var nextUrl = newLoadmore.getAttribute('data-next-url');
            container.setAttribute('data-next-url', nextUrl);
            if (btn) btn.setAttribute('href', nextUrl);
            setLoading(false);
            if (mode === 'infinite') observe();
          } else {
            container.remove();
          }
        })
        .catch(function () {
          setLoading(false);
        });
    }

    function observe() {
      if (!('IntersectionObserver' in window)) return;
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            loadNext(container.getAttribute('data-next-url'));
          }
        });
      }, { rootMargin: '400px' });
      observer.observe(container);
    }

    if (btn && !btn._mbBound) {
      btn._mbBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        loadNext(container.getAttribute('data-next-url'));
      });
    }

    if (mode === 'infinite') {
      if (btn) btn.style.display = 'none';
      observe();
    }
  }

  function swapCatalog(root, browserUrl, fetchUrl) {
    var gridWrap = root.querySelector('[data-mb-catalog-gridwrap]');
    var caption = root.querySelector('[data-mb-catalog-caption]');
    var mobileCount = root.querySelector('[data-mb-catalog-mobilecount]');
    var filterScrim = root.querySelector('[data-mb-catalog-sheet-scrim="filter"]');
    var wasOpen = !!(filterScrim && filterScrim.classList.contains('mb-catalog__sheet-scrim--open'));

    if (gridWrap) gridWrap.classList.add('mb-catalog__grid-wrap--loading');

    return fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGridWrap = doc.querySelector('[data-mb-catalog-gridwrap]');
        var newCaption = doc.querySelector('[data-mb-catalog-caption]');
        var newMobileCount = doc.querySelector('[data-mb-catalog-mobilecount]');

        if (newGridWrap && gridWrap) {
          gridWrap.replaceWith(newGridWrap);
          if (wasOpen) {
            var newFilterScrim = newGridWrap.querySelector('[data-mb-catalog-sheet-scrim="filter"]');
            if (newFilterScrim) {
              newFilterScrim.classList.add('mb-catalog__sheet-scrim--open');
              document.body.classList.add('mb-catalog-sheet-open');
            }
          }
          bindGridWrap(root);
        }
        if (newCaption && caption) {
          caption.innerHTML = newCaption.innerHTML;
        }
        if (newMobileCount && mobileCount) {
          mobileCount.textContent = newMobileCount.textContent;
        }

        if (window.history && window.history.pushState) {
          window.history.pushState({ mbCatalog: true }, '', browserUrl);
        }
      })
      .catch(function () {
        // Fetch failed for any reason — fall back to a real navigation
        // rather than leaving the UI stuck.
        window.location.href = browserUrl;
      })
      .finally(function () {
        var stillThere = root.querySelector('[data-mb-catalog-gridwrap]');
        if (stillThere) stillThere.classList.remove('mb-catalog__grid-wrap--loading');
      });
  }

  function initFilterForm(root) {
    var form = root.querySelector('[data-mb-catalog-form]');
    if (!form || form._mbBound) return;
    form._mbBound = true;

    var collectionUrl = root.getAttribute('data-collection-url');
    var sectionId = root.getAttribute('data-section-id');

    function submit() {
      var params = new URLSearchParams(new FormData(form));
      var browserUrl = collectionUrl + '?' + params.toString();
      var fetchUrl = browserUrl + '&section_id=' + sectionId;
      swapCatalog(root, browserUrl, fetchUrl);
    }

    form.addEventListener('change', submit);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit();
    });
  }

  function initFilterLinks(root) {
    // Active-filter chips and "Clear all" are plain <a> links to a
    // different query string — AJAX those the same way as the form so
    // removing a filter doesn't fall back to a full reload.
    root.querySelectorAll('[data-mb-catalog-gridwrap] a.mb-catalog__chip, [data-mb-catalog-gridwrap] a.mb-catalog__clear').forEach(function (link) {
      if (link._mbBound) return;
      link._mbBound = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var browserUrl = link.getAttribute('href');
        var sectionId = root.getAttribute('data-section-id');
        var joiner = browserUrl.indexOf('?') === -1 ? '?' : '&';
        var fetchUrl = browserUrl + joiner + 'section_id=' + sectionId;
        swapCatalog(root, browserUrl, fetchUrl);
      });
    });
  }

  function bindGridWrap(root) {
    initFilterForm(root);
    initFilterLinks(root);
    initSheets(root);
    root.querySelectorAll('[data-mb-catalog-loadmore]').forEach(initLoadMore);
  }

  function initRoot(root) {
    bindGridWrap(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mb-catalog-root]').forEach(initRoot);
  });

  // Filtered/sorted states are pushed to the URL bar; on back/forward,
  // do a real reload to guarantee the page matches the URL exactly
  // rather than re-implementing AJAX state restoration.
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.mbCatalog) {
      window.location.reload();
    }
  });
})();